<template>
  <div class="is-clickable is-primary">
    <div
      class="
        main-content main-card
        is-flex is-justify-content-center
        has-background-primary
      "
      @click.stop="onclick"
    >
      <div style="flex: 2; display: grid; margin: auto">
        <div class="is-size-7 is-flex has-text-white px-1">
          <div style="flex: 1" class="is-size-6 pt-2">
            {{ "Last day" | t }}
          </div>
          <div style="flex: 1">
            <b style="flex: 1; font-size: 10px">{{ "Max" | t }}</b>
            <div v-if="lastDay.max" style="flex: 1; font-size: 13px">
              {{ lastDay.max.Value }}
            </div>
            <div v-if="lastDay.max" style="flex: 1; font-size: 12px">
              @ {{ lastDay.max.DisplayTime }} น
            </div>
          </div>
          <div style="flex: 1">
            <b style="flex: 1; font-size: 10px">{{ "Min" | t }}</b>
            <div v-if="lastDay.min" style="flex: 1; font-size: 13px">
              {{ lastDay.min.Value }}
            </div>
            <div v-if="lastDay.min" style="flex: 1; font-size: 12px">
              @ {{ lastDay.min.DisplayTime }} น
            </div>
          </div>
        </div>
        <!-- <div
                    class="is-size-7 is-flex has-text-white is-align-items-baseline px-1"
                >
                    <div style="flex:1" class="is-size-6">
                        {{ "Last day" | t }}
                    </div>
                    <div style="flex:1">5.27</div>
                    <div style="flex:1">3.56</div>
                </div>
                <div class="is-size-7 is-flex has-text-white px-1">
                    <div style="flex:1"></div>
                    <div style="flex:1;font-size:10px">@ 10.32</div>
                    <div style="flex:1;font-size:10px">@ 11.32</div>
                </div> -->

        <div
          class="is-size-4 has-text-white"
          style="border-top: 0.2px solid rgba(255, 255, 255, 0.1)"
        >
          {{ $t(title) }}
        </div>
        <div class="is-size-1 has-text-white">
          {{ currentValue | twoDigit }}
          <span class="is-size-5">{{ unit }}</span>
        </div>
      </div>
      <div
        style="flex: 1; padding: 0px 7px 7px 0px; position: relative"
        class="is-flex is-flex-direction-column"
      >
        <div class="main-last-update-display has-text-white">
          {{ lastUpdateDisplay }}
        </div>
        <div style="flex: 1; position: relative" @click.stop>
          <div
            style="
              position: absolute;
              top: 0px;
              bottom: 0px;
              left: 0px;
              right: 0px;
            "
            ref="chart"
          ></div>
        </div>
      </div>
    </div>
    <div v-if="showTable">
      <FilterTable
        :filter-loading="filterLoading"
        @onApplyFilter="onApplyFilter"
        @onResetFilter="onResetFilter"
      ></FilterTable>
      <b-table
        ref="table"
        header-class="header-table"
        :data="data"
        hoverable
        striped
        narrowed
        :columns="columns"
        :mobile-cards="false"
      >
      </b-table>
      <div class="footer-action">
        <b-button size="is-small" type="is-info is-light" @click="onLoadMore">
          {{ $t("load more") }}
        </b-button>
        <b-button
          size="is-small"
          type="is-danger is-light"
          @click="showExport = true"
        >
          {{ $t("export") }}
        </b-button>
      </div>
      <div v-if="showExport" class="export">
        <ExportBox
          @on-close="showExport = false"
          @on-export="onExportCSV"
          :loading="exportLoading"
        ></ExportBox>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as echarts from "echarts";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { aggregateHourly } from "@/utils/aggregate";
import toTwoDigit from "@/utils/toTwoDigit";
import { API, graphqlOperation } from "aws-amplify";
import * as subscriptions from "@/graphql/subscriptions";
import Cronr from "cronr";
dayjs.extend(relativeTime);

export default {
  name: "DeviceFieldCard",
  props: {
    title: String,
    clientid: String,
    serial: String,
    field: String,
    src: Array,
    info: Object,
    Point: Object,
    thingID: String,
    unit: String,
    id: Number,
  },
  components: {
    FilterTable: () => import("@/components/TableFilter.vue"),
    ExportBox: () => import("@/components/ExportBox.vue"),
  },
  data() {
    return {
      subscription: null,
      polling: null,
      lastUpdate: dayjs(),
      lastUpdateDisplay: "",
      showTable: false,
      showExport: false,
      exportLoading: false,
      chart: null,
      resizeObserver: null,
      showDetailIcon: true,
      columnsVisible: {
        name: { title: "Name", display: true },
        sold: { title: "Stock Sold", display: true },
        available: { title: "Stock Available", display: true },
        cleared: { title: "Stock Cleared", display: true },
      },
      currentValue: null,
      start: null,
      end: null,
      isNextPreviousDate: false,
      raw: [],
      lastDay: {
        max: null,
        min: null,
      },
      filter: {
        start: null,
        end: null,
      },
      filterLoading: false,
      data: [
        // {
        //     date: "18/08/2021",
        //     time: "17:00",
        //     DO: 1.4,
        //     change: "+0.7",
        // },
        // {
        //     date: "18/08/2021",
        //     time: "18:00",
        //     DO: 2.1,
        //     change: "+1.1",
        // },
        // {
        //     date: "18/08/2021",
        //     time: "19:00",
        //     DO: 3.2,
        //     // change: ,
        // },
      ],
    };
  },
  computed: {
    columns() {
      return [
        {
          field: "Date",
          label: "Date",
          centered: true,
        },
        {
          field: "Time",
          label: "Time",
          centered: true,
        },
        {
          field: this.title,
          label: this.title,
          centered: true,
        },
        {
          field: "Change",
          label: "Change",
          centered: true,
        },
      ];
    },
    // Hourly() {
    //     return aggregateHourly(this.data);
    // },
  },
  watch: {
    thingID: {
      immediate: false,
      handler: function () {
        this.cleanup();
        this.init();
      },
    },
  },
  filters: {
    twoDigit(value) {
      if ([null, undefined].indexOf(value) < 0) {
        return toTwoDigit(value);
      }
      return "n/a";
    },
  },
  mounted() {
    // this.lastUpdateDisplay = this.lastUpdate.fromNow();
    // setInterval(() => {
    //     this.lastUpdateDisplay = this.lastUpdate.fromNow();
    // }, 30000);
    this.init();
  },
  methods: {
    init() {
      // NOTE initial
      this.createChart();
      this.fetchData().then(() => {
        this.draw();
        this.calculateLastDayMinMax();
      });
      this.subscribe();
      this.polling = new Cronr("0 0,30 * * * *", () => {
        console.log("trigger!");
        this.fetchData();
        this.end = null;
        this.start = null;
      });
      this.polling.start();
    },
    async fetchData() {
      try {
        let result;
        if (this.id != null || this.id != undefined) {
          result = await this.$store.dispatch("timeseries/getLatestStream", {
            thingID: this.thingID,
            field: this.id + "#" + this.field,
          });
        } else {
          result = await this.$store.dispatch("timeseries/getLatestStream", {
            thingID: this.thingID,
            field: this.field,
          });
        }

        console.log(result);
        this.currentValue = result.Point.Value;
        this.lastUpdateDisplay = dayjs.unix(result.Point.Timestamp).fromNow();
        this.data = aggregateHourly(result.Points).reduceRight(
          (acc, i, index, origin) => {
            const p = i;
            p[this.field] = toTwoDigit(i.Value);
            if (origin[index - 1]) {
              const change = toTwoDigit(i.Value - origin[index - 1].Value);
              p.Change = (change <= 0 ? "" : "+") + change;
            }
            acc.push(p);
            return acc;
          },
          []
        );
        this.raw = result.Points;
      } catch (error) {
        console.error(error);
      }
    },
    async onLoadMore() {
      if (this.data.length <= 0) {
        return;
      }
      try {
        if (!this.isNextPreviousDate) {
          this.end = dayjs.unix(this.data[this.data.length - 1].Timestamp);
        }
        this.start = this.end.subtract(1, "day");
        console.log(this.start.date(), this.end.date());

        let result;
        if (this.id != null || this.id != undefined) {
          result = await this.$store.dispatch("timeseries/getTimeseries", {
            thingID: this.thingID,
            field: this.id + "#" + this.field,
            start: this.start.unix(),
            end: this.end.unix(),
          });
        } else {
          result = await this.$store.dispatch("timeseries/getTimeseries", {
            thingID: this.thingID,
            field: this.field,
            start: this.start.unix(),
            end: this.end.unix(),
          });
        }
        const newdata = aggregateHourly(result.Points).reduceRight(
          (acc, i, index, origin) => {
            const p = i;
            p[this.field] = toTwoDigit(i.Value);
            if (origin[index - 1]) {
              const change = toTwoDigit(i.Value - origin[index - 1].Value);
              p.Change = (change <= 0 ? "" : "+") + change;
            }
            acc.push(p);
            return acc;
          },
          []
        );
        this.raw = result.Points;
        this.data = this.data.concat(newdata);
        this.isNextPreviousDate = false;
      } catch (error) {
        console.error(error);
        this.end = this.end.subtract(1, "day");
        this.isNextPreviousDate = true;
      }
    },
    calculateLastDayMinMax() {
      console.log("calculateLastDayMinMax");

      const today = dayjs();
      const startOfToday = today.startOf("day");
      const startOfLastday = startOfToday.subtract(1, "day");

      const lastDayData = this.raw.filter((x) => {
        if (
          startOfToday.unix() > x.Timestamp &&
          startOfLastday.unix() < x.Timestamp
        ) {
          return true;
        }
        return false;
      });

      let max = lastDayData.reduce((a, b) => (a.Value > b.Value ? a : b));
      let min = lastDayData.reduce((a, b) => (a.Value < b.Value ? a : b));
      max.Value = max.Value.toFixed(2);
      min.Value = min.Value.toFixed(2);
      max.DisplayTime = dayjs.unix(max.Timestamp).format("HH:mm");
      min.DisplayTime = dayjs.unix(min.Timestamp).format("HH:mm");
      this.lastDay.max = max;
      this.lastDay.min = min;
    },
    onclick() {
      this.showTable = !this.showTable;
    },
    createChart() {
      this.chart = echarts.init(this.$refs.chart);
      this.resizeObserver = new ResizeObserver((entries) => {
        // console.log("Size changed", entries[0].contentRect);
        // let { width, height } = entries[0].contentRect;
        // this.w = width;
        // this.h = height;
        this.chart.resize();
        //   entries[0].contentRect
      });
      this.resizeObserver.observe(this.$refs.chart);
    },
    draw() {
      let data = this.raw.slice(-10);

      if (data.length < 10) {
        for (let index = data.length; index <= 10; index++) {
          data.unshift({
            Timestamp: null,
            Value: null,
          });
        }
      }

      let option = {
        color: ["#FFFFFF"],
        xAxis: {
          type: "category",
          data: data.map((i) => {
            if (i.Timestamp) {
              return dayjs.unix(i.Timestamp).format("HH:mm");
            }
            return null;
          }),
          // data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          axisLabel: {
            show: true,
            color: "rgba(255, 255, 255, 0.25)",
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          position: "right",
          show: true,
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: "#ffffff",
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.1)",
            },
          },
        },
        grid: {
          left: "10px",
          right: "30px",
          bottom: "5px",
        },
        tooltip: {
          show: true,
          // trigger: "axis",
        },
        // legend: {
        //     data: ["蒸发量", "降水量"],
        // },
        // toolbox: {
        //     show: true,
        //     feature: {
        //         dataView: { show: true, readOnly: false },
        //         magicType: { show: true, type: ["line", "bar"] },
        //         restore: { show: true },
        //         saveAsImage: { show: true },
        //     },
        // },
        series: [
          {
            data: data.map((i) => {
              if (i.Value) {
                return toTwoDigit(i.Value);
              }
              return null;
            }),
            type: "bar",
            // coordinateSystem: 'polar',
            backgroundStyle: {
              borderRadius: 10,
              borderColor: "#000000",
            },
            roundCap: true,
            itemStyle: {
              emphasis: {
                barBorderRadius: [4, 4],
                color: "hsl(171, 100%, 41%)",
              },
              normal: {
                barBorderRadius: [4, 4, 4, 4],
              },
            },
          },
        ],
      };

      option && this.chart.setOption(option);
    },
    subscribe() {
      if (this.id != null || this.id != undefined) {
        this.subscription = API.graphql(
          graphqlOperation(
            subscriptions.onCreateThingTimeseriesByThingIdAndFieldName,
            {
              thingID: this.thingID,
              fieldName: this.id + "#" + this.field,
            }
          )
        ).subscribe({
          next: ({ provider, value }) => {
            console.log({ provider, value });
            const point = {
              Timestamp:
                value.data.onCreateThingTimeseriesByThingIDAndFieldName
                  .timestamp,
              Value:
                value.data.onCreateThingTimeseriesByThingIDAndFieldName.mean,
            };
            this.raw = [...this.raw, point];
            this.currentValue = point.Value;
            this.lastUpdateDisplay = dayjs.unix(point.Timestamp).fromNow();
            this.draw();
          },
          error: (error) => console.warn(error),
        });
      } else {
        this.subscription = API.graphql(
          graphqlOperation(
            subscriptions.onCreateThingTimeseriesByThingIdAndFieldName,
            {
              thingID: this.thingID,
              fieldName: this.field,
            }
          )
        ).subscribe({
          next: ({ provider, value }) => {
            console.log({ provider, value });
            const point = {
              Timestamp:
                value.data.onCreateThingTimeseriesByThingIDAndFieldName
                  .timestamp,
              Value:
                value.data.onCreateThingTimeseriesByThingIDAndFieldName.mean,
            };
            this.raw = [...this.raw, point];
            this.currentValue = point.Value;
            this.lastUpdateDisplay = dayjs.unix(point.Timestamp).fromNow();
            this.draw();
          },
          error: (error) => console.warn(error),
        });
      }
    },
    cleanup() {
      console.log("cancel polling and unsubscribe");
      this.subscription && this.subscription.unsubscribe();
      this.polling && this.polling.stop();
    },
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    async onApplyFilter(filter) {
      console.log("onApplyFilter: ", filter);
      try {
        this.filterLoading = true;
        const startDate = dayjs(filter.start)
          .startOf("day")
          .add(7, "hour")
          .unix();
        const endDate = dayjs(filter.end).endOf("day").add(7, "hour").unix();
        console.log("filter ", startDate, endDate);
        let result;
        if (this.id != null || this.id != undefined) {
          result = await this.$store.dispatch("timeseries/getTimeseries", {
            thingID: this.thingID,
            field: this.id + "#" + this.field,
            start: startDate,
            end: endDate,
          });
        } else {
          result = await this.$store.dispatch("timeseries/getTimeseries", {
            thingID: this.thingID,
            field: this.field,
            start: startDate,
            end: endDate,
          });
        }

        const newdata = aggregateHourly(result.Points).reduceRight(
          (acc, i, index, origin) => {
            const p = i;
            p[this.field] = toTwoDigit(i.Value);
            if (origin[index - 1]) {
              const change = toTwoDigit(i.Value - origin[index - 1].Value);
              p.Change = (change <= 0 ? "" : "+") + change;
            }
            acc.push(p);
            return acc;
          },
          []
        );

        this.data = newdata;

        console.log(result);
      } catch (error) {
        this.data = [];
        console.log(error);
      } finally {
        this.filterLoading = false;
      }
    },
    async onExportCSV(params) {
      console.log("onExportCSV", params);
      try {
        this.exportLoading = true;

        //Create parameter
        const startDate = dayjs(params.start)
          .startOf("day")
          .add(7, "hour")
          .unix();
        const endDate = dayjs(params.end).endOf("day").add(7, "hour").unix();
        console.log("filter ", startDate, endDate);

        //Fetch data
        let result;
        if (this.id != null || this.id != undefined) {
          result = await this.$store.dispatch("timeseries/getTimeseries", {
            thingID: this.thingID,
            field: this.id + "#" + this.field,
            start: startDate,
            end: endDate,
          });
        } else {
          result = await this.$store.dispatch("timeseries/getTimeseries", {
            thingID: this.thingID,
            field: this.field,
            start: startDate,
            end: endDate,
          });
        }
        console.log("export result", result);

        const p = result.Points.map((point) => {
          const ux = dayjs.unix(point.Timestamp).second(0);
          return {
            Date: ux.format("DD/MM/BB"),
            Time: ux.format("HH:mm"),
            Timestamp: ux,
            Value: point.Value,
          };
        });

        // console.log("point p", p);

        const newdata = p.reduceRight((acc, i, index, origin) => {
          const p = i;
          p[this.field] = toTwoDigit(i.Value);
          p["TwoDigitValue"] = toTwoDigit(i.Value);
          if (origin[index - 1]) {
            const change = toTwoDigit(i.Value - origin[index - 1].Value);
            p.Change = (change <= 0 ? "" : "+") + change;
          }
          acc.push(p);
          return acc;
        }, []);

        console.log("newdata", newdata);

        // Convert to csv
        // - Create header
        const headers = {
          date: "Date",
          time: "Time",
          value: `${this.field}`,
          change: "Change",
        };

        const fileTitle = `report-field-${
          this.id ? this.id + "#" + this.field : this.field
        }_(${dayjs.unix(startDate)}-${dayjs.unix(endDate)})`;

        let itemsFormatted = [];

        newdata.forEach((data) => {
          const newdate = data.Date.split("/");
          itemsFormatted.push({
            date: `${newdate[0]}/${newdate[1]}/25${newdate[2]}`,
            time: data.Time,
            value: data.TwoDigitValue,
            change: data.Change,
          });
        });
        console.log("itemsFormatted", itemsFormatted);

        this.exportCSVFile(headers, itemsFormatted, fileTitle);
      } catch (error) {
        console.error(error);
      } finally {
        this.exportLoading = false;
      }
    },
    onResetFilter() {
      console.log("onResetFilter");
      this.init();
    },
    exportCSVFile(headers, items, fileTitle) {
      if (headers) {
        items.unshift(headers);
      }
      // Convert Object to JSON
      var jsonObject = JSON.stringify(items);
      var csv = this.convertToCSV(jsonObject);
      var exportedFilenmae = fileTitle + ".csv" || "export.csv";
      var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, exportedFilenmae);
      } else {
        var link = document.createElement("a");
        // console.log("link", link.download)
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", exportedFilenmae);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
    convertToCSV(objArray) {
      var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
      var str = "";
      for (var i = 0; i < array.length; i++) {
        var line = "";
        for (var index in array[i]) {
          if (line != "") line += ",";
          line += array[i][index];
        }
        str += line + "\r\n";
      }
      return str;
    },
  },
  beforeDestroy() {
    this.cleanup();
  },
};
</script>

<style scoped>
.main-card {
  overflow: hidden;
  border-radius: 15px;
}
.main-content {
  position: relative;
  min-height: 200px;
  /* aspect-ratio: 3; */
  /* border: 1px solid #1c75e0; */
}
.main-title {
  /* position: absolute; */
  font-size: 13.33px;
}
.main-value-title {
  font-size: 0.3em;
  /* align-self: center; */
}
.main-last-update-display {
  position: absolute;
  top: 4px;
  right: 4px;
  font-size: 11px;
}
.header-table {
  border: 1px solid green;
}
.date-select {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px;
}
.filtering {
  padding: 15px;
  margin: 10px 0;
  border-radius: 15px;
  height: inherit;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  background-color: rgb(250, 250, 250);
}
.action {
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: 10px;
}
.footer-action {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: center;
  margin-top: 10px;
}
@media screen and (max-width: 400px) {
  .filtering {
    flex-direction: column;
  }
}
</style>
